<template>
	<div :class="containerClass" @click="onWrapperClick">

        <IKLoader :isVisible="exibirLoader"/>
       
        <AppTopBar @menu-toggle="onMenuToggle" :usuarioLogado="usuarioLogado"/>

        <transition name="layout-sidebar">
            <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link to="/">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </router-link>
                </div>         
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>

		<div class="layout-main">           
			<router-view />
		</div>

		<AppFooter />  

        <Toast />
        
	</div>
    
</template>

<script>
import AppTopBar from '@/components/template/AppTopbar.vue';
import AppMenu from '@/components/template/AppMenu.vue';
import AppFooter from '@/components/template/AppFooter.vue';
import http from '@/plugins/axios/axios';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            usuarioLogado: '',
            exibirLoader: false,
            layoutMode: 'static',
            layoutColorMode: 'dark',
            //layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu : []
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario', 'getPermissoes']), 
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
		onLayoutColorChange(layoutColorMode) {
			this.layoutColorMode = layoutColorMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth > 1024;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
                else
                    return true;
            }
            else {
                return true;
            }
        },
        configurarInterceptorAxios() {
            let vueInstance = this;            
            http.interceptors.request.use(function(config) {  
                let arrUrl = config.url.split('?');
                if(arrUrl.length > 1 && arrUrl[1].includes('fdb=f')) {
                    return config;
                } 
                vueInstance.exibirLoader = true;
                return config;
            }, function(erro) {
                vueInstance.exibirLoader = false;               
                return Promise.reject(erro);
            });  
            http.interceptors.response.use((response) => {
                vueInstance.exibirLoader = false;
                return response
            }, function(erro) {
                vueInstance.exibirLoader = false;
                return Promise.reject(erro);
            });      
        },    
        carregarMenu() {
            let menu = [
                {
                    label: 'Home', icon: 'pi pi-fw pi-home', to: '/', permissao: 0},
                {   label: 'Cadastros', icon: 'pi pi-fw pi-folder', permissao: 49,
                    items: [
                        {label: 'Empresas', icon: 'pi pi-fw pi-calendar', to: '/cadastros/empresas', permissao: 29}, 
                        {
                            label: 'Dispositivos de Coleta', icon: 'pi pi-fw pi-calendar', permissao: 142,
                            items: [
                                {label: 'Cliente App', icon: 'pi pi-fw pi-calendar', to: '/cadastros/dispositivos-coletas/cliente-app', permissao: 142},
                                {label: 'Marcação Online', icon: 'pi pi-fw pi-clock', to: '/cadastros/dispositivos-coletas/marcacao-online', permissao: 160},
                                {label: 'Relógio de Ponto', icon: 'pi pi-fw pi-clock', to: '/cadastros/dispositivos-coletas/relogio-ponto', permissao: 153},
                                {label: 'Serviço Push', icon: 'pi pi-fw pi-clock', to: '/cadastros/dispositivos-coletas/monitoramento-push', permissao: 173}
                            ]
                        },
                        {label: 'Feriados', icon: 'pi pi-fw pi-calendar', to: '/cadastros/feriados', permissao: 33},
                        {label: 'Centros de Custos', icon: 'pi pi-fw pi-calendar', to: '/cadastros/centros-custos', permissao: 14},                        
                        {label: 'Cargos', icon: 'pi pi-fw pi-calendar', to: '/cadastros/cargos', permissao: 19},
                        {label: 'Escalas de Horários', icon: 'pi pi-fw pi-calendar', to: '/cadastros/escalas-horarios', permissao: 70},
                        {label: 'Funcionários', icon: 'pi pi-fw pi-calendar', to: '/cadastros/funcionarios', permissao: 24},                        
                        {label: 'Justificativas', icon: 'pi pi-fw pi-calendar', to: '/cadastros/justificativas', permissao: 90},
                        {label: 'Motivos de Afastamento', icon:  'pi pi-fw pi-calendar', to: '/cadastros/motivos-afastamento', permissao: 75},
                        
                    ]
                    
                },
                {   label: 'Movimento', icon: 'pi pi-fw pi-folder', permissao: 112,
                    items: [
                         {label: 'Afastamentos', icon: 'pi pi-fw pi-calendar', to: '/movimento/afastamentos', permissao: 102},
                         {label: 'Escalas de Folgas', icon: 'pi pi-fw pi-calendar', to: '/cadastros/escalas-folgas', permissao: 95},
                         {label: 'Ocorrências', icon: 'pi pi-fw pi-calendar', to: '/movimento/ocorrencias', permissao: 108},
                         {label: 'Mudança de Horário', icon: 'pi pi-fw pi-calendar', to: '/movimento/mudanca-horario', permissao: 115},
                         {label: 'Banco de Horas', icon: 'pi pi-fw pi-calendar', to: '/movimento/banco-horas', permissao: 120},
                         {label: 'Fechar Período', icon: 'pi pi-fw pi-calendar', to: '/movimento/concluir-fechar-periodo', permissao: 150},
                         {label: 'Cálculo do Ponto', icon: 'pi pi-fw pi-calendar', to: '/movimento/calculo-ponto', permissao: 125},
                         {label: 'Controle do Ponto', icon: 'pi pi-fw pi-calendar', to: '/movimento/controle-ponto', permissao: 126}, 
                         {label: 'Solicitações', icon: 'pi pi-fw pi-calendar', to: '/movimento/solicitacoes', permissao: 165},                         
                    ]
                    
                },
                {   label: 'Cadastro', icon: 'pi pi-fw pi-folder', permissao: 99999,
                    items: [
                         {label: 'Clientes', icon:  'pi pi-fw pi-calendar', to: '/cadastro/adm/clientes', permissao: 99999},
                         {label: 'Planos', icon:  'pi pi-fw pi-calendar', to: '/cadastro/adm/planos', permissao: 99999},
                         {label: 'Update-Funcionarios', icon:  'pi pi-fw pi-users', to: '/cadastro/adm/upload', permissao: 99999}                          
                    ]
                    
                },
                {label: 'Relatórios', icon: 'pi pi-fw pi-bars', to: '/relatorios', permissao: 128},
                {label: 'Documentos', icon: 'pi pi-fw pi-file', to: '/documentos', permissao: 133},
                {label: 'Relatórios', icon: 'pi pi-fw pi-bars', to: '/relatorios-adm', permissao: 99999},
            ]
            return menu;
        },
        processarItensMenuPermissao() {
            let menuFiltro = this.carregarMenu();
            let permissoes = this.getPermissoes();
            let menuFiltrado = [];
            menuFiltro.forEach(menu => {
                if(permissoes.includes(menu.permissao)) {
                    if(typeof menu.items === 'undefined') {
                        menuFiltrado.push(menu);
                    } else {
                        menu.items = this.filtrarMenu(menu.items, permissoes);
                        if(menu.items.length > 0) {
                            menuFiltrado.push(menu);
                        }
                    }
                }
            }); 
            this.menu = menuFiltrado;
        },
        filtrarMenu(itensMenu, permissoes) {
           let menuFiltrado = [];
           itensMenu.forEach(menu => {
               if(permissoes.includes(menu.permissao)) {
                    if(typeof menu.items === 'undefined') {
                        menuFiltrado.push(menu);
                    } else {
                        menu.items = this.filtrarMenu(menu.items, permissoes);
                        if(menu.items.length > 0) {
                            menuFiltrado.push(menu);
                        }
                    }
                }
           }); 
           return menuFiltrado;
        },
    },
    computed: {
        containerClass() {       
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$appState.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.ripple === false
            }];
        },
        sidebarClass() {
            return ['layout-sidebar', {
                'layout-sidebar-dark': this.layoutColorMode === 'dark',
                'layout-sidebar-light': this.layoutColorMode === 'light'
            }];
        },
        logo() {
            //return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
            return "./assets/logo_ikponto.jpg";
        }
    },
    created() {
        this.processarItensMenuPermissao();
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    mounted() {
        this.configurarInterceptorAxios();
        this.usuarioLogado = this.getUsuario().nome;
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,       
        'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">

    .p-toast.p-toast-topright {
        z-index: 1000;
        top: 70px;
    }

</style>